import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import config from '../../config/config'
import { getToken, isSentry } from '../../lib'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import { SpanError } from '../../layouts/Domain/styles.js'
import CheckIcon from 'material-ui/svg-icons/action/check-circle'
import images from '../../config/images'
import authenticate from '../../layouts/authenticateHOC'
import { connect } from 'react-redux'
import * as actions from '../../layouts/LoggedIn/actions'
import { shouldRedirectUserToLogin } from '../../layouts/LoggedIn/actions'

const APIurl = `${config.URI}/api/v1/domains/`
let domainRoute = `/domain`

class Domain extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      connections: 0,
      description: '',
      trial: true,
      expire: moment(),
      create: props.location.pathname === `${domainRoute}/create` ? true : false,
      url: '',
      expire_flag: false,
      status: 'expire',
      max_room_num_per_user: 0,
      max_account_num: 0,
      fv_domains_name: '',
      errors: {},
      users: '',
      verify: ''
    }
  }

  async componentDidMount () {
    const sessionToken = sessionStorage.getItem('authToken')
    const localToken = localStorage.getItem('authToken')
    if (sessionToken === null && localToken === null) {
      this.props.history.push('/login')
    }
    if (!this.state.create) {
      await fetch(`${APIurl}${this.props.computedMatch.params.id}`, {
        method: 'GET',
        headers: {
          'Authenticity-Token': getToken(),
          'Content-Type': 'application/json'
        }
      })
        .then((temp) => temp.json())
        .then(res => {
          if (res.status && res.status === 'success') {
            this.setState({
              name: res.data.domain.name,
              connections: res.data.domain.connections,
              trial: res.data.domain.trial,
              description: res.data.domain.description,
              expire: moment(res.data.domain.expire),
              url: res.data.domain.url,
              expire_flag: res.data.expire_flag,
              status: res.data.domain.status,
              max_room_num_per_user: res.data.domain.max_room_num_per_user ? res.data.domain.max_room_num_per_user : 0,
              max_account_num: res.data.domain.max_account_num ? res.data.domain.max_account_num : 0,
              fv_domains_name: res.data.domain.fv_domains_name ? res.data.domain.fv_domains_name : 0,
              users: res.data.users,
              verify: res.data.verify
            })
          }
        })
        .catch((error) => {
          isSentry(error)
        })
    }
  }

  validate = (data) => {
    const errors = {}
    if (!this.state.name || this.state.name.length === 0) errors.name = '入力してください'
    if (!this.state.connections || this.state.connections <= 1) errors.connections = '同時接続数を入力してください'
    if (!this.state.expire) errors.expire = '有効期限を入力してください'
    if (this.state.description.length > 500) errors.description = '300文字以内で入力してください'
    return errors
  }
  save = (method, payload, URL) => {
    fetch(URL, {
      method: method,
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          if (method === 'POST') {
            alert('ドメインの作成に成功しました。')
            window.location = domainRoute
          }
          else {
            alert('ドメインの更新に成功しました')
            window.location.reload()
          }
        } else {
          if (res.errors === 'Fv domains name has already been taken') {
            alert('すでに、そのドメイン名は存在しています')
          }
          else {
            res.errors.map((val, index) => (alert(val)))
          }
        }
      })
      .catch((error) => {
        alert('サーバーとの接続にエラーが発生しました。')
        isSentry(error)
      })
  }
  handleSubmit = e => {
    e.preventDefault()
    const errors = this.validate(this.state)
    this.setState({errors})
    if (Object.keys(errors).length !== 0) {
      return
    }
    const payload = {
      name: this.state.name,
      connections: this.state.connections,
      description: this.state.description,
      trial: this.state.trial,
      expire: this.state.expire._d,
      status: this.state.status,
      max_room_num_per_user: this.state.max_room_num_per_user,
      max_account_num: this.state.max_account_num,
      fv_domains_name: this.state.fv_domains_name
    }
    if (this.state.create) {
      const URL = `${APIurl}`
      const method = 'POST'
      return this.save(method, payload, URL)
    } else {
      const URL = `${APIurl}${this.props.computedMatch.params.id}`
      const method = 'PUT'
      return this.save(method, payload, URL)
    }
  }

  destroy = () => {
    return fetch(`${config.URI}/api/v1/domains/${this.props.computedMatch.params.id}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          alert('ドメインの削除に成功しました')
          window.location = '/domain'
        } else {
          res.errors.map((val, index) => (alert(val)))
        }
      })
      .catch((error) => {
        alert('サーバーとの接続にエラーが発生しました。')
        isSentry(error)
      })
  }

  render () {
    return (
      <div>
        <Link to={domainRoute}>
          {'戻る(Back)'}
        </Link>
        <form onSubmit={this.handleSubmit}>
          <br/>
          <br/>
          <label>
            ステータス(Status)：
            {this.state.status === 'expire' ? <null> {this.state.expire_flag ? '無効' : '有効'} </null> : null}
            {this.state.status === 'valid' && '有効'}
            {this.state.status === 'invalid' && '無効'}
          </label>
          <br/>
          <br/>
          <label>
            会社名(Company Name):
            <input type="text" value={this.state.name} onChange={(e) => this.setState({name: e.target.value})}/>
            {this.state.errors && this.state.errors.name &&
            <SpanError>{this.state.errors.name}</SpanError>}
          </label>
          <br/>
          <br/>
          <label>
            最大接続数(maximum connections number):
            <input type="number" min="0" value={this.state.connections}
                   onChange={(e) => this.setState({connections: e.target.value})}/>
            {this.state.errors && this.state.errors.connections &&
            <SpanError>{this.state.errors.connections}</SpanError>}
          </label>
          <br/>
          <br/>
          <label>
            契約(Contract)：
            <select value={this.state.trial}
                    onChange={(e) => this.setState({trial: (e.target.value === 'true') ? true : false})}>
              <option value={true}>トライアル</option>
              <option value={false}>本契約</option>
            </select>
          </label>
          <br/>
          <br/>
          <label>
            モード(Mode)：
            <select value={this.state.status} onChange={(e) => this.setState({status: e.target.value})}>
              <option value={'expire'}>有効期限ON</option>
              <option value={'valid'}>有効(強制)</option>
              <option value={'invalid'}>無効(強制)</option>
            </select>
          </label>
          <br/>
          <br/>
          {this.state.status === 'expire' && <label>
            有効期限(Expires)：
            <DatePicker
              selected={this.state.expire}
              onChange={(e) => this.setState({expire: e})}
            />
          </label>}
          {this.state.errors && this.state.errors.expire &&
          <SpanError>{this.state.errors.expire}</SpanError>}
          <br/>
          <br/>
          <br/>
          <br/>
          <label>
            補足事項(Notes):
            <textarea style={{width: 400, height: 200}} value={this.state.description}
                      onChange={(e) => this.setState({description: e.target.value})}/>
            {this.state.errors && this.state.errors.description &&
            <SpanError>{this.state.errors.description}</SpanError>}
            <br/>
            <br/>
            <br/>
            <br/>
            {!this.state.create && <label>
              ユーザ作成用URL(The url link of creating the new user):
              <p>{`${window.location.host}/signup/?url=${this.state.url}`}</p>
            </label>}
            <br/>
            <br/>
          </label>
          {this.state.create ? <input type="submit" value="新規ドメインの作成(Create the new domain)"/> :
            <input type="submit" value="ドメインの更新(Update this domain)"/>}
        </form>

        {false && <button onClick={() => this.destroy()}>
          ドメインの削除を行う(Delete this domain)
        </button>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    redirectToLogin: state.loginLayout.redirectToLogin,
    tokenVerified: state.loginLayout.tokenVerified,
    isLoggedIn: state.login.isLoggedIn,
    open: state.loginLayout.open,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  returnUserIfUserExists: token =>
    dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token =>
    dispatch(actions.checkTokenOnPathChange(token)),
  shouldRedirectUserToLogin: bool => dispatch(shouldRedirectUserToLogin(bool)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(authenticate(Domain)))



// WEBPACK FOOTER //
// ./src/routes/Domain/create.js